import {Injectable, inject} from '@angular/core';
import {Subscription} from 'rxjs';
import {I18nService} from './i18n.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {first} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private i18nService = inject(I18nService);
  private snackBar = inject(MatSnackBar);


  private i18nSubscription: Subscription;

  public display(message: string, duration: number = 5000): void {
    this.snackBar.open(message, null, {duration: duration, panelClass: ['tu-snackbar']});
  }

  public displayI18n(i18n: string, data?: Record<string, unknown>, duration: number = 5000): void {
    if(this.i18nSubscription) {
      this.i18nSubscription.unsubscribe();
    }
    this.i18nSubscription = this.i18nService.getTranslation(i18n, data || {}).pipe(first()).subscribe(value => this.display(value, duration));
  }

  public dismiss(): void {
    this.snackBar.dismiss();
  }

}
